module.exports = __webpack_public_path__ + "img/ebook-pubu.a4b61dd7.png";